import { render } from "./CopyInvoice.vue?vue&type=template&id=2ab0b4c3&scoped=true"
import script from "./CopyInvoice.vue?vue&type=script&lang=js"
export * from "./CopyInvoice.vue?vue&type=script&lang=js"

import "./CopyInvoice.vue?vue&type=style&index=0&id=2ab0b4c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab0b4c3"]])

export default __exports__